import styled, { keyframes } from "styled-components"

import Hero from "@components/Hero/Hero"
import { MEDIA_QUERIES } from "@constants"
import { getImgixUrl } from "@utils"

const BackgroundKeyframes = keyframes`
  0% {
    background-position-y: 0;
  }

  100% {
    background-position-y: var(--spacing--XL);
  }
`

export const HomeHeroWrapperDIV = styled.div`
  padding-bottom: calc(var(--spacing--L) + var(--spacing--XL));
  position: relative;

  .Hero {
    padding: calc(var(--SiteNav--height) + var(--spacing--M)) 0 calc(var(--spacing--XS) + var(--spacing--M));
  }

  .BentoBoxBlock.uid--20PkVfVnaCai5xAMrY9z6b {
    margin-bottom: var(--spacing--L);

    .flex {
      gap: var(--spacing--base-0-75);
    }

    .BentoBoxBlock--Card {
      flex-direction: column-reverse;
      background: white;
      box-shadow: var(--elevation--M--on-dark);
      justify-content: start;
      padding: var(--spacing--S) var(--spacing--base-1-5);

      ${MEDIA_QUERIES.M} {
        flex: 0 0 calc(50% - var(--spacing--base-0-75) / 2);

        &:last-child {
          flex: 0 0 100%;
        }
      }
      
      ${MEDIA_QUERIES.L} {
        &,
        &:last-child {
          flex: 0 0 calc(33.3333% - var(--spacing--base-0-75) * 2 / 3);
        }
      }

      .image {
        .Media {
          text-align: center;
        }

        .gatsby-image-wrapper {
          max-width: max(288px, calc(var(--base-unit) * 18));
        }
      }

      .content {
        text-align: center;
        padding: 0;

        h3 {
          font-weight: var(--font-weight--medium);
          font-size: var(--font-size--3XL);
        }

        p {
          color: var(--color--text-default);
          font-size: var(--font-size--XL);
          margin-bottom: var(--spacing--base-1-25);
          text-wrap: balance;
        }
      }
    }
  }

  .HomeHero--quote {
    .flex {
      align-items: center;
      justify-content: center;
      gap: var(--spacing--XS) var(--spacing--M);
    }

    p {
      text-align: center;
      text-wrap: balance;

      ${MEDIA_QUERIES.M} {
        text-align: left;
      }

      &::before {
        content: "“";
      }
      &::after {
        content: "”";
      }
    }

    .quote-attribution {
      align-items: center;
      display: flex;
      gap: var(--spacing--base-0-75);

      span {
        opacity: 0.8;
      }
    }
  }

  .HomeHero--background {
    background-color: var(--color--clay-100);
    background-position: center top;
    background-size: cover;
    bottom: var(--spacing--XL);
    height: calc(100% - var(--spacing--XL));
    left: 0;
    overflow: hidden;
    position: absolute;
    width: 100%;
    will-change: background-position;
    z-index: -1;

    ${MEDIA_QUERIES.M} {
      background-size: 2000px 100%;
      background-position-x: left;
    }

    ${MEDIA_QUERIES.L} {
      background-position-x: center;
    }

    @media (min-width: 2000px) {
      background-size: 100% 100%;
    }

    @supports ((animation-timeline: scroll()) and (animation-range: 0% 100vh)) {
      animation: ${BackgroundKeyframes} linear both;
      animation-timeline: scroll(root);
      animation-range: 0% 100vh;
    }

    &::before {
      background: url(${getImgixUrl("/images/noise-overlay.png", 120, 120)});
      content: "";
      display: block;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 2;
      mix-blend-mode: screen;
    }
  }
`

export const HomeHeroHERO = styled(Hero)`
  padding: calc(var(--SiteNav--height) + var(--spacing--L)) 0 var(--spacing--L);

  h1 {
    margin-bottom: var(--spacing--base-3);
    text-wrap: balance;

    ${MEDIA_QUERIES.L} {
      margin-bottom: var(--spacing--base-1-5);
    }
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing--XS) var(--spacing--base-0-75);

    .Button {
      flex: 0 0 100%;
    }

    ${MEDIA_QUERIES.M} {
      flex-wrap: nowrap;
      width: calc(50% - var(--spacing--base-0-75) / 2);

      .Button {
        flex: 0 0 calc(50% - var(--spacing--base-0-75) / 2);
      }
    }

    ${MEDIA_QUERIES.XL} {
      width: calc(33.3333% - var(--spacing--base-0-75) / 2);
    }
  }
`
